module.exports = __webpack_public_path__ + "img/stage_sonnenblume.1a854065.jpg";